// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noDataAvailableWrapper{
    margin: 50px 0px !important;
    text-align: center;
}
.gangCardWrapper{
  padding: 14px 14px;
  background-color:  #c8e2fa;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  font-weight: 600;
  color: var(--blue);
  /* cursor: pointer; */
  transition: 0.3s all ease-in-out;
}
/* .gangCardWrapper:hover{
    background-color:  #daecfd;
    transition: 0.3s all ease-in-out;
    color: var(--blue);
  } */

.expandedTableWrapper{
    width: 100% ;
    overflow-x:auto;   
    background-color: #eef7fe;
}

.expandedTableWrapper table{
    width: 100%;
    table-layout: auto;
}
  
.expandedTableWrapper thead tr th{
    padding: 6px 8px
}
.expandedTableWrapper tr td{
    padding: 6px 8px;
}

.pageNotFoundWrapper{
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.pageNotFoundWrapper h1{
    font-size: 70px;
    font-weight: 700;
}

/* ------------- Media Query------------------- */
@media (max-width: 1000px) {
    .noDataAvailableWrapper{
        font-size: 14px;
    }
}
@media (max-width: 750px) {
    .noDataAvailableWrapper{
        font-size: 12px;
    }
    .gangCardWrapper{
        font-size: 14px !important;
        padding: 10px 14px;
    }
    .gangCardWrapper >div{
        gap: 20px !important;
    }
    .expandedTableWrapper thead tr th{
        padding: 6px 8px;
        font-size: 14px !important;
    }
    .expandedTableWrapper tr td{
        font-size: 12px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/pages.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;;;;KAIK;;AAEL;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;AACJ;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,iDAAiD;AACjD;IACI;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".noDataAvailableWrapper{\n    margin: 50px 0px !important;\n    text-align: center;\n}\n.gangCardWrapper{\n  padding: 14px 14px;\n  background-color:  #c8e2fa;\n  display: flex;\n  justify-content: space-between;\n  border-radius: 6px;\n  font-weight: 600;\n  color: var(--blue);\n  /* cursor: pointer; */\n  transition: 0.3s all ease-in-out;\n}\n/* .gangCardWrapper:hover{\n    background-color:  #daecfd;\n    transition: 0.3s all ease-in-out;\n    color: var(--blue);\n  } */\n\n.expandedTableWrapper{\n    width: 100% ;\n    overflow-x:auto;   \n    background-color: #eef7fe;\n}\n\n.expandedTableWrapper table{\n    width: 100%;\n    table-layout: auto;\n}\n  \n.expandedTableWrapper thead tr th{\n    padding: 6px 8px\n}\n.expandedTableWrapper tr td{\n    padding: 6px 8px;\n}\n\n.pageNotFoundWrapper{\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n}\n\n.pageNotFoundWrapper h1{\n    font-size: 70px;\n    font-weight: 700;\n}\n\n/* ------------- Media Query------------------- */\n@media (max-width: 1000px) {\n    .noDataAvailableWrapper{\n        font-size: 14px;\n    }\n}\n@media (max-width: 750px) {\n    .noDataAvailableWrapper{\n        font-size: 12px;\n    }\n    .gangCardWrapper{\n        font-size: 14px !important;\n        padding: 10px 14px;\n    }\n    .gangCardWrapper >div{\n        gap: 20px !important;\n    }\n    .expandedTableWrapper thead tr th{\n        padding: 6px 8px;\n        font-size: 14px !important;\n    }\n    .expandedTableWrapper tr td{\n        font-size: 12px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
